// encryption.js
import CryptoJS from "crypto-js";
import { getSecretByName } from "../redux/action/keyVaultAction";
import store from "../redux/store";

let encryptionKey = null;

async function getEncryptionKey() {
    if (encryptionKey) {
        return encryptionKey;
    }

    const resolvedKey = process.env.REACT_APP_IS_AZURE_VAULT
        ? process.env.REACT_APP_ENCRYPTION_KEY
        : await store.dispatch(getSecretByName("WEB-ENCRYPTION-KEY"));

    if (!resolvedKey) {
        throw new Error("Encryption key is not configured");
    }

    encryptionKey = resolvedKey;
    return encryptionKey;
}

function getKeyUtf8(keyValue) {
    // Pad or slice key to 32 bytes for AES-256
    let keyUtf8 = CryptoJS.enc.Utf8.parse(keyValue);
    const keyWords = keyUtf8.words;
    const keySigBytes = keyUtf8.sigBytes;

    if (keySigBytes === 32) return keyUtf8;

    // Pad with zeros if shorter than 32 bytes
    if (keySigBytes < 32) {
        const zerosNeeded = 32 - keySigBytes;
        const zeroWords = new Array(Math.ceil(zerosNeeded / 4)).fill(0);
        const newWords = keyWords.concat(zeroWords);
        return CryptoJS.lib.WordArray.create(newWords, 32);
    }

    // Slice if longer than 32 bytes
    return CryptoJS.lib.WordArray.create(keyWords.slice(0, 8), 32); // 8 words * 4 bytes = 32 bytes
}

export async function encryptUserId(userId) {
    const key = getKeyUtf8(await getEncryptionKey());
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(String(userId), key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.stringify({
        iv: CryptoJS.enc.Base64.stringify(iv),
        content: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
    });
}
